<template lang="pug">
  div.items-area(:style="area()")
    div.slit(v-for="(n , i) in slits",v-if="i !== slits.length - 1",:style="sty(i)")
      div.items(:style="styItems()")
        Item(v-for="(nc , ss) in slits[i].item",:dat="nc",:pnum="i",:num="ss",:key="ss")
      div.flr
        FItem(v-for="(nc , ss) in slits[i].floor",:dat="nc",:pnum="i",:num="ss",:key="ss")
      div.prev
    div.warning(v-if="$store.state.isWarning.message !== ''" :style="styWarning()")
      .btn-close(@click="hideSaveArea")
        img(src="@/assets/ico_close_red.svg")
      p(style='margin-top: 15px')(v-html="$store.state.isWarning.message")
</template>

<script>
import store from '../../stores/index';
import Item from './Item.vue';
import FItem from './FItem.vue';
export default {
  name: 'Items',
  components: {
    Item,
    FItem
  },
  data () {
    return {
      $info: {},
      parent: 0,
      child: 0,
      height: 0,
      hole: 0,
      $tar: {},
      dragged: {},
      slits: []
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    }
  },
  methods: {
    update () {
      if (this.sets[this.number] !== undefined) {
        this.slits = this.sets[this.number].slits;
        this.hole = Number(this.slits[0].slit.hole);
      }
    },
    sty (num) {
      if (this.sets[this.number] === undefined) return false;
      let width = this.c2p(this.slits[num + 1].pos - this.slits[num].pos);
      this.height = this.c2p(this.sets[this.number].size[1]);
      let left = this.c2p(this.slits[num].pos);
      return {
        width: width + 'px',
        height: this.height + this.c2p(this.sets[this.number].size[3]) + 'px',
        left: left + 'px'
      };
    },
    styItems () {
      if (this.sets[this.number] === undefined) return false;
      let height = this.c2p(this.sets[this.number].size[1]);
      return {
        height: height + 'px'
      };
    },
    styFloor () {
      if (this.sets[this.number] === undefined) return false;
      let height = this.c2p(this.sets[this.number].size[3]);
      return {
        height: height + 'px'
      };
    },
    styWarning () {
      let left = this.c2p(this.$store.state.isWarning.position) + 10;
      let width = this.c2p(this.$store.state.isWarning.width) - 20;
      let height = width > 130 ? '' : this.c2p(this.$store.state.isWarning.width) - 30;
      let fontsize = width > 130 ? 16 : 12;
      return {
        width: width + 'px',
        left: left + 'px',
        height: height + 'px',
        'font-size': fontsize + 'px'
      };
    },
    hideSaveArea () {
      const result = {
        message: '',
        position: ''
      };
      store.commit('setMessageWarning', result);
    },
    area () {
      if (this.sets[this.number] === undefined) return false;
      this.height2 = this.c2p(this.sets[this.number].size[1] + this.sets[this.number].size[3]);
      return {
        height: this.height2 + 'px'
      };
    },
    ondragstart (e) {
    },
    ondragover (event) {
    },
    ondragleave (event) {
    },
    ondragend (event) {
    },
    ondrop (event) {
    },
    checkSlit (event) {
    },
    removeDragdrop () {
    }
  },
  created () {
    this.update();
  },
  beforeDestroy () {
  },
  mounted () {
  }
};
</script>

<style lang="stylus" scoped>
  .items-area
    left 0
    top 0
    position absolute
    z-index 3
    .slit
      position absolute
      left 0
      top 0
      width 170px
      height 48px
      &.over
        .item,
        .prev
          display block
          pointer-events none
      &.floorOver
        .flr
          opacity 1
          &:before
            content ""
            display block
            position absolute
            left 0
            right 0
            top 0
            bottom 0
            border 1px solid #ff0000
  .items
    width 100%
    position relative
    z-index 1
    &:hover
      z-index 10
  .flr
    position absolute
    left 0
    bottom 0
    width 100%
    height 10px
    z-index 2
    &:hover
      z-index 10
  .prev
    display none
    border 1px solid #cc0000
    width 100%
    height 10px
    position absolute
    left 0
  .warning
    background-color #fff
    position absolute
    display flex
    justify-content center
    font-weight bold
    color red
    flex-direction column
    align-items center
    text-align center
    height 15%
    margin-top 15px
    z-index 999
    top 20%
    border 2px solid red
    width 275px
  .btn-close
    position absolute
    top 0px
    right 3px
    cursor pointer
    img
      width 12px
</style>



// WEBPACK FOOTER //
// src/components/front/Items.vue